import { createApp } from "./js/app/create-app.js";

createApp();
